import { SpinboxAddToCart } from 'components/Blocks/Product/AddToCart/SpinboxAddToCart';
import { ProductStock } from 'components/Blocks/Product/Availability/ProductStock';
import { Item, ItemProps, TEST_IDENTIFIER } from 'components/Blocks/Product/CategoryPromotedProducts/Item/Item';
import { ProductLink } from 'components/Blocks/Product/CategoryPromotedProducts/Item/ProductLink';
import { ProductCatnum } from 'components/Blocks/Product/List/ListedItem/ProductCatnum';
import { B2bProductPrice } from 'components/Blocks/Product/Price/B2bProductPrice';
import WatchDog from 'components/Blocks/Product/WatchDog/WatchDog';

export const B2bItem: FC<ItemProps> = ({ item, gtmListName, listIndex }) => {
    return (
        <Item item={item}>
            <div className="mr-2 flex flex-1 items-center text-center text-small font-bold">
                <div className="w-3/5 pr-3 text-left" data-testid={TEST_IDENTIFIER + 'name'}>
                    <ProductLink gtmListName={gtmListName} item={item} listIndex={listIndex} />
                    <ProductCatnum catalogNumber={item.catalogNumber} />
                </div>

                <div className="mr-2 block w-2/5 text-left">
                    <ProductStock
                        minimumSellingQuantity={item.b2bMinimumProductOrder ?? 1}
                        quantity={item.stockQuantity}
                    />
                </div>
            </div>

            <div className="block w-40 items-center justify-end text-right">
                <B2bProductPrice
                    b2bPaymentDiscount={item.b2bPaymentDiscount}
                    basePrice={item.prices.basic}
                    isUnitPrice={(item.b2bMinimumProductOrder ?? 0) > 1}
                    sellingPrice={item.price}
                    variant="narrow"
                />
            </div>

            <div className="ml-4 w-40">
                {item.isSellingDenied ||
                item.maximumOrderableQuantity <= 0 ||
                (item.b2bMinimumProductOrder ?? 0) > item.maximumOrderableQuantity ? (
                    <WatchDog productName={item.fullName} productUuid={item.uuid} />
                ) : (
                    <SpinboxAddToCart
                        gtmListName={gtmListName}
                        listIndex={listIndex}
                        product={item}
                        spinboxIdSuffix="-promoted"
                        variant="iconOnly"
                    />
                )}
            </div>
        </Item>
    );
};
